import { useLocalStorage } from '@rehooks/local-storage';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { GoogleAnalytics } from './GoogleAnalytics';
import { GoogleAnalytics4 } from './GoogleAnalytics4';
import { GoogleTagManager } from './GoogleTagManager';
class Trackers {
    constructor(trackerIds) {
        this.trackerIds = trackerIds;
    }
    static getTrackers(trackerIds) {
        if (!this.trackers) {
            this.trackers = new Trackers(trackerIds);
        }
        return this.trackers;
    }
    enable() {
        const { googleAnalyticsId, googleAnalytics4Id, googleTagManagerId } = this.trackerIds;
        if (!this.googleAnalytics && googleAnalyticsId) {
            this.googleAnalytics = new GoogleAnalytics(googleAnalyticsId);
        }
        if (!this.googleAnalytics4 && googleAnalytics4Id) {
            this.googleAnalytics4 = new GoogleAnalytics4(googleAnalytics4Id);
        }
        if (!this.googleTagManager && googleTagManagerId) {
            this.googleTagManager = new GoogleTagManager(googleTagManagerId);
        }
    }
    disable() {
        this.googleAnalytics = undefined;
        this.googleAnalytics4 = undefined;
        this.googleTagManager = undefined;
        GoogleTagManager.removeScript();
    }
    event(event) {
        var _a, _b;
        (_a = this.googleAnalytics) === null || _a === void 0 ? void 0 : _a.event(event);
        (_b = this.googleAnalytics4) === null || _b === void 0 ? void 0 : _b.event(event);
    }
    trackPage(page) {
        var _a, _b;
        (_a = this.googleAnalytics) === null || _a === void 0 ? void 0 : _a.pageView(page);
        (_b = this.googleAnalytics4) === null || _b === void 0 ? void 0 : _b.pageView(page);
    }
}
const deleteAllCookies = () => {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].trim();
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie =
            name +
                '=;domain=.lalilo.com;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;';
    }
};
export const useCookieSettings = () => useLocalStorage('cookies_enable_tracking', null);
export const useTrackers = (args) => {
    const isTrackingEnabled = useIsTrackingEnabled(args);
    const location = useLocation();
    const trackers = Trackers.getTrackers(args.trackersParameters.trackerIds);
    useEffect(() => {
        if (isTrackingEnabled) {
            trackers.enable();
        }
        else {
            trackers.disable();
            deleteAllCookies();
        }
    }, [isTrackingEnabled, trackers]);
    useEffect(() => {
        trackers.trackPage(location.pathname + location.search);
    }, [location.pathname, location.search, trackers]);
    return trackers;
};
export const useIsTrackingEnabled = (args) => {
    const [isUserTrackingEnabled] = useCookieSettings();
    const { isP2IAFullVersionUser, isP2iaPage, isUserInFrance } = args;
    return (isUserTrackingEnabled === true &&
        isUserInFrance !== null &&
        !isUserInFrance &&
        !isP2IAFullVersionUser &&
        !isP2iaPage);
};
//# sourceMappingURL=useTrackers.js.map